import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { QueryResult, SearchOptionsModel } from '@app/data/models';
import { EmailTemplateModel } from '@app/data/models/email-template.model';
import { errorHandler, getData, verifyServerResult } from '@app/data/operators';
import { Environment, ServerResult } from '@app/shared/models';
import { APP_ENVIRONMENT } from '@app/shared/tokens';

@Injectable()
export class ManageEmailTemplatesService {
    private env = inject<Environment>(APP_ENVIRONMENT);
    private http = inject(HttpClient);

    searchTemplates(model: SearchOptionsModel) {
        return this.http
            .post<ServerResult<QueryResult<EmailTemplateModel>>>(
                `${this.env.serverUrl}/manage/email-templates/search-for-list`,
                model,
            )
            .pipe(verifyServerResult(), getData(), errorHandler());
    }

    getAllEmailTemplates() {
        return this.http
            .get<ServerResult<EmailTemplateModel[]>>(`${this.env.serverUrl}/manage/email-templates/all`)
            .pipe(verifyServerResult(), getData(), errorHandler());
    }
}
